import effectivenessGraph from "../../../../content/blog/assets/ea/effectiveness-graph.png";
import gates from "../../../../content/blog/assets/ea/gates.jpg";
import pledge from "../../../../content/blog/assets/ea/pledge.jpg";
import * as React from 'react';
export default {
  effectivenessGraph,
  gates,
  pledge,
  React
};